<template>
  <authorization permissionKey="island_therapy_queue" can="read">
    <Attendances
      v-if="attendancePlace"
      queueType="therapy"
      :attendancePlaceId="attendancePlace.id"
      :pollInterval=60000
    >
      <template v-slot:attendance="{ attendance }">
        <AttendanceTherapyList :attendance="attendance" />
      </template>
    </attendances>
  </authorization>
</template>

<script>
  import Attendances from "@/components/queues/attendances.vue";
  import AttendanceTherapyList from "@/components/attendance_therapy/list/index.vue";

  export default {
    name: "TherapyQueue",
    components: {
      Attendances,
      AttendanceTherapyList,
    },
    props: {
      attendancePlace: Object,
    },
  };
</script>

<style lang="scss" scoped></style>
